import _ from 'lodash';

const getPackageChanges = (passengers, originalPassengers) => {
  const packageChanges = [];
  if (!originalPassengers || !passengers || passengers.length !== originalPassengers.length) {
    return packageChanges;
  }
  for (let index = 0; index < passengers.length; index += 1) {
    const updatedPackages = (passengers[index].travelerPreferences || {}).selectedPackages || [];
    const packages = (originalPassengers[index].travelerPreferences || {}).selectedPackages || [];
    const removed = _.differenceBy(packages, updatedPackages, 'key');
    const added = _.differenceBy(updatedPackages, packages, 'key');
    if (added.length) {
      added.forEach((p) => {
        packageChanges.push({
          passenger: passengers[index],
          package: p,
          action: 'Selected',
        });
      });
    }
    if (removed.length) {
      removed.forEach((p) => {
        packageChanges.push({
          passenger: passengers[index],
          package: p,
          action: 'Unselected',
        });
      });
    }
  }
  return packageChanges;
};

export default getPackageChanges;
